var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-section"},[_c('div',{staticClass:"login-wrap"},[_vm._m(0),_c('div',{staticClass:"login-btn-wrap"},[_c('a',{staticClass:"roo-btn w-button",on:{"click":_vm.home}},[_vm._v("Home")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-header-wrap"},[_c('h1',{staticClass:"roo-h1"},[_vm._v("Page Not Found")]),_c('h4',{staticClass:"roo-h4"},[_vm._v("Hop back home")])])
}]

export { render, staticRenderFns }